

export const isPoEditingEnabled = (selectedGroup: any) => {
    // check if the selected group allows PO editing
    return selectedGroup?.extraction_field_list?.po_editing_enabled == 1;
}


export const getPoEditingFields = (selectedGroup: any) => {
    // check if the selected group allows PO editing
    return (selectedGroup?.extraction_field_list?.po_editing_fields || "").split(",").map((field: string) => field.trim()).filter((field: string) => field.length > 0);
}


// 🕰️ convert a rehydrate key (yyyymmddHHsshh) to a Date; returns null if unparseable

export const rehydrateKeyToDate = (key: string): Date | null => {
    // yyyy mm dd HH ss hh → note: format per spec is year-month-day-hour-second-millisecond (no minutes)
    const s = String(key);
    if (s.length < 12) return null;
    const year = Number(s.slice(0, 4));
    const month = Number(s.slice(4, 6)) - 1;
    const day = Number(s.slice(6, 8));
    const hour = Number(s.slice(8, 10));
    const sec = Number(s.slice(10, 12));
    const d = new Date(year, month, day, hour, 0, sec);
    return isNaN(d.getTime()) ? null : d;
};

// 🕰️ parse a rehydrate datetime key (yyyymmddHHsshh) to a comparable number (leaves fmt as-is; string compare works too)
export const parseRehydrateKeyToMs = (key: string): number => {
    // key format: yyyymmddHHsshh — lexicographic order matches chronological order, so a numeric parse is enough for comparison
    const n = Number(key);
    return isNaN(n) ? 0 : n;
};

export const smoothScrollLeft = (container: HTMLElement, left: number) => {
    if (!container) return;
    container?.scrollTo({ left: left, behavior: 'smooth' });
}